const STORAGE_KEY = 'talkytimesTranslationSettings';

export const TRANSLATION_PROVIDER_YOUDAO = 'youdao';
export const TRANSLATION_PROVIDER_LLM = 'llm';
export const TRANSLATION_PROVIDER_TOKENHUB = 'tokenhub';
export const TRANSLATION_PROVIDER_TOKENHUB_RESPONSES = 'tokenhub-responses';

export const TRANSLATION_PROVIDERS = [
  { id: TRANSLATION_PROVIDER_LLM, name: '大模型' },
  { id: TRANSLATION_PROVIDER_YOUDAO, name: '有道翻译' },
  { id: TRANSLATION_PROVIDER_TOKENHUB, name: '混元翻译' },
];

/** 是否启用 TokenHub 混元翻译（Responses 已在代码中从引擎列表移除） */
export function isTokenHubTranslationEnabled() {
  return true;
}

function isProviderEnabled(providerId) {
  if (
    providerId === TRANSLATION_PROVIDER_YOUDAO ||
    providerId === TRANSLATION_PROVIDER_LLM
  ) {
    return true;
  }
  if (providerId === TRANSLATION_PROVIDER_TOKENHUB) {
    return isTokenHubTranslationEnabled();
  }
  return false;
}

export function getAvailableTranslationProviders() {
  return TRANSLATION_PROVIDERS.filter((item) => isProviderEnabled(item.id));
}

function getDefaultSettings() {
  return {
    provider: TRANSLATION_PROVIDER_YOUDAO,
  };
}

function resolveProvider(provider) {
  const availableIds = getAvailableTranslationProviders().map((item) => item.id);
  if (provider && availableIds.includes(provider)) {
    return provider;
  }
  return TRANSLATION_PROVIDER_YOUDAO;
}

export function getTranslationSettings() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        provider: resolveProvider(parsed.provider),
      };
    }
  } catch (error) {
    console.error('读取翻译设置失败:', error);
  }
  return { ...getDefaultSettings() };
}

export function setTranslationSettings(partial) {
  const next = {
    ...getTranslationSettings(),
    ...partial,
  };
  next.provider = resolveProvider(next.provider);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
}

export function getTranslationOptions() {
  const settings = getTranslationSettings();
  return {
    provider: settings.provider,
  };
}

/** 消息列表：强制混元翻译，未启用时用当前手选引擎 */
export function getMessageTranslationProvider() {
  if (isTokenHubTranslationEnabled()) {
    return TRANSLATION_PROVIDER_TOKENHUB;
  }
  return getTranslationSettings().provider || TRANSLATION_PROVIDER_LLM;
}
